import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from '@RankHR/Regions/commands-core'

export function useCreateRegionCommandV1(
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)

	const result = {
		id: _id,
		name: _name,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }

			return new c.CreateRegionCommandV1(_id.value, _name.value)
		})
	}

	return {
		...result,
		authorizedCreateRegionCommandV1: result.authorized,
		createRegionCommandV1: result.command,
		completedCreateRegionCommandV1: result.completed,
		errorCreateRegionCommandV1: result.error,
		invokeCreateRegionCommandV1: result.invoke,
		invokingCreateRegionCommandV1: result.invoking,
		succeedCreateRegionCommandV1: result.succeed,
		validationErrorsCreateRegionCommandV1: result.validationErrors,
		onSucceedCreateRegionCommandV1: result.onSucceed,
	}
}

export function useCreateVotingCycleCommandV1(
	id?: string | Ref<string> | (() => string), 
	votingCycle?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _votingCycle = isRef<string>(votingCycle) ? votingCycle : ref<string>((typeof votingCycle === 'function') ? votingCycle() : votingCycle)

	const result = {
		id: _id,
		votingCycle: _votingCycle,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof votingCycle === 'function') { _votingCycle.value = votingCycle() }

			return new c.CreateVotingCycleCommandV1(_id.value, _votingCycle.value)
		})
	}

	return {
		...result,
		authorizedCreateVotingCycleCommandV1: result.authorized,
		createVotingCycleCommandV1: result.command,
		completedCreateVotingCycleCommandV1: result.completed,
		errorCreateVotingCycleCommandV1: result.error,
		invokeCreateVotingCycleCommandV1: result.invoke,
		invokingCreateVotingCycleCommandV1: result.invoking,
		succeedCreateVotingCycleCommandV1: result.succeed,
		validationErrorsCreateVotingCycleCommandV1: result.validationErrors,
		onSucceedCreateVotingCycleCommandV1: result.onSucceed,
	}
}

export function useDisableAnonymousModeCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.DisableAnonymousModeCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedDisableAnonymousModeCommandV1: result.authorized,
		disableAnonymousModeCommandV1: result.command,
		completedDisableAnonymousModeCommandV1: result.completed,
		errorDisableAnonymousModeCommandV1: result.error,
		invokeDisableAnonymousModeCommandV1: result.invoke,
		invokingDisableAnonymousModeCommandV1: result.invoking,
		succeedDisableAnonymousModeCommandV1: result.succeed,
		validationErrorsDisableAnonymousModeCommandV1: result.validationErrors,
		onSucceedDisableAnonymousModeCommandV1: result.onSucceed,
	}
}

export function useEnableAnonymousModeCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.EnableAnonymousModeCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedEnableAnonymousModeCommandV1: result.authorized,
		enableAnonymousModeCommandV1: result.command,
		completedEnableAnonymousModeCommandV1: result.completed,
		errorEnableAnonymousModeCommandV1: result.error,
		invokeEnableAnonymousModeCommandV1: result.invoke,
		invokingEnableAnonymousModeCommandV1: result.invoking,
		succeedEnableAnonymousModeCommandV1: result.succeed,
		validationErrorsEnableAnonymousModeCommandV1: result.validationErrors,
		onSucceedEnableAnonymousModeCommandV1: result.onSucceed,
	}
}

export function useRemoveVotingCycleCommandV1(
	id?: string | Ref<string> | (() => string), 
	votingCycle?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _votingCycle = isRef<string>(votingCycle) ? votingCycle : ref<string>((typeof votingCycle === 'function') ? votingCycle() : votingCycle)

	const result = {
		id: _id,
		votingCycle: _votingCycle,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof votingCycle === 'function') { _votingCycle.value = votingCycle() }

			return new c.RemoveVotingCycleCommandV1(_id.value, _votingCycle.value)
		})
	}

	return {
		...result,
		authorizedRemoveVotingCycleCommandV1: result.authorized,
		removeVotingCycleCommandV1: result.command,
		completedRemoveVotingCycleCommandV1: result.completed,
		errorRemoveVotingCycleCommandV1: result.error,
		invokeRemoveVotingCycleCommandV1: result.invoke,
		invokingRemoveVotingCycleCommandV1: result.invoking,
		succeedRemoveVotingCycleCommandV1: result.succeed,
		validationErrorsRemoveVotingCycleCommandV1: result.validationErrors,
		onSucceedRemoveVotingCycleCommandV1: result.onSucceed,
	}
}

export function useSetCriteriaVersionCommandV1(
	id?: string | Ref<string> | (() => string), 
	criteriaVersion?: string | Ref<string> | (() => string), 
	votingCycle?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _criteriaVersion = isRef<string>(criteriaVersion) ? criteriaVersion : ref<string>((typeof criteriaVersion === 'function') ? criteriaVersion() : criteriaVersion)
	const _votingCycle = isRef<string>(votingCycle) ? votingCycle : ref<string>((typeof votingCycle === 'function') ? votingCycle() : votingCycle)

	const result = {
		id: _id,
		criteriaVersion: _criteriaVersion,
		votingCycle: _votingCycle,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof criteriaVersion === 'function') { _criteriaVersion.value = criteriaVersion() }
			if (typeof votingCycle === 'function') { _votingCycle.value = votingCycle() }

			return new c.SetCriteriaVersionCommandV1(_id.value, _criteriaVersion.value, _votingCycle.value)
		})
	}

	return {
		...result,
		authorizedSetCriteriaVersionCommandV1: result.authorized,
		setCriteriaVersionCommandV1: result.command,
		completedSetCriteriaVersionCommandV1: result.completed,
		errorSetCriteriaVersionCommandV1: result.error,
		invokeSetCriteriaVersionCommandV1: result.invoke,
		invokingSetCriteriaVersionCommandV1: result.invoking,
		succeedSetCriteriaVersionCommandV1: result.succeed,
		validationErrorsSetCriteriaVersionCommandV1: result.validationErrors,
		onSucceedSetCriteriaVersionCommandV1: result.onSucceed,
	}
}

export function useStartVotingCycleCommandV1(
	id?: string | Ref<string> | (() => string), 
	votingCycle?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _votingCycle = isRef<string>(votingCycle) ? votingCycle : ref<string>((typeof votingCycle === 'function') ? votingCycle() : votingCycle)

	const result = {
		id: _id,
		votingCycle: _votingCycle,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof votingCycle === 'function') { _votingCycle.value = votingCycle() }

			return new c.StartVotingCycleCommandV1(_id.value, _votingCycle.value)
		})
	}

	return {
		...result,
		authorizedStartVotingCycleCommandV1: result.authorized,
		startVotingCycleCommandV1: result.command,
		completedStartVotingCycleCommandV1: result.completed,
		errorStartVotingCycleCommandV1: result.error,
		invokeStartVotingCycleCommandV1: result.invoke,
		invokingStartVotingCycleCommandV1: result.invoking,
		succeedStartVotingCycleCommandV1: result.succeed,
		validationErrorsStartVotingCycleCommandV1: result.validationErrors,
		onSucceedStartVotingCycleCommandV1: result.onSucceed,
	}
}

export function useStopVotingCycleCommandV1(
	id?: string | Ref<string> | (() => string), 
	votingCycle?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _votingCycle = isRef<string>(votingCycle) ? votingCycle : ref<string>((typeof votingCycle === 'function') ? votingCycle() : votingCycle)

	const result = {
		id: _id,
		votingCycle: _votingCycle,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof votingCycle === 'function') { _votingCycle.value = votingCycle() }

			return new c.StopVotingCycleCommandV1(_id.value, _votingCycle.value)
		})
	}

	return {
		...result,
		authorizedStopVotingCycleCommandV1: result.authorized,
		stopVotingCycleCommandV1: result.command,
		completedStopVotingCycleCommandV1: result.completed,
		errorStopVotingCycleCommandV1: result.error,
		invokeStopVotingCycleCommandV1: result.invoke,
		invokingStopVotingCycleCommandV1: result.invoking,
		succeedStopVotingCycleCommandV1: result.succeed,
		validationErrorsStopVotingCycleCommandV1: result.validationErrors,
		onSucceedStopVotingCycleCommandV1: result.onSucceed,
	}
}

export function useSwitchVotingCycleCommandV1(
	id?: string | Ref<string> | (() => string), 
	votingCycle?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _votingCycle = isRef<string>(votingCycle) ? votingCycle : ref<string>((typeof votingCycle === 'function') ? votingCycle() : votingCycle)

	const result = {
		id: _id,
		votingCycle: _votingCycle,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof votingCycle === 'function') { _votingCycle.value = votingCycle() }

			return new c.SwitchVotingCycleCommandV1(_id.value, _votingCycle.value)
		})
	}

	return {
		...result,
		authorizedSwitchVotingCycleCommandV1: result.authorized,
		switchVotingCycleCommandV1: result.command,
		completedSwitchVotingCycleCommandV1: result.completed,
		errorSwitchVotingCycleCommandV1: result.error,
		invokeSwitchVotingCycleCommandV1: result.invoke,
		invokingSwitchVotingCycleCommandV1: result.invoking,
		succeedSwitchVotingCycleCommandV1: result.succeed,
		validationErrorsSwitchVotingCycleCommandV1: result.validationErrors,
		onSucceedSwitchVotingCycleCommandV1: result.onSucceed,
	}
}

